// Hero background video — plays the muted, looping <video>(s) only when it's
// appropriate. We render them WITHOUT the autoplay attribute and start playback
// here so we can honour prefers-reduced-motion and Save-Data (slower / metered
// connections, common for our shoppers). When we don't play, the video's poster
// image shows instead — so the hero still looks right with zero motion / data.

(function () {
  function init() {
    const wraps = document.querySelectorAll('.hero__video');
    if (!wraps.length) return;

    const reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || saveData) return; // leave paused → poster shows

    wraps.forEach((wrap) => {
      // Skip the crop that's hidden at this viewport (no point buffering it).
      if (getComputedStyle(wrap).display === 'none') return;
      const video = wrap.querySelector('video');
      if (!video) return;
      video.muted = true; // required for programmatic autoplay
      const played = video.play();
      if (played && typeof played.catch === 'function') {
        played.catch(function () {
          /* autoplay blocked — poster stays visible, which is fine */
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
